<template>
  <div class="our-beliefs-credibility-content" id="plataforma-de-marca-nossas-crencas-credibilidade-aproxima" data-search-anchor>
    <div class="our-beliefs-credibility-overlay-title-image">
      <h1 class="our-beliefs-credibility-image-credibility-title" style="margin-top: 4rem; margin-bottom: 2rem;">
        {{ ourBeliefsCredibilityImageTitle }}
      </h1>
      
      <p class="our-beliefs-credibility-image-credibility-text">
        {{ ourBeliefsCredibilityImageTitle2 }}
      </p>
    </div>

    <div
      class="our-beliefs-credibility-banner-image"
      :style="{ backgroundImage: `url(${ourBeliefsCredibilityImageSrc})` }"
    ></div>
  </div>  
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import OurBeliefsPageMixin from '@/mixins/our-beliefs-page-mixin'
import { OurBeliefsPageStore } from '@/store/brand-plataform-page/our-beliefs-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurBeliefsCredibilitySection extends Mixins(OurBeliefsPageMixin) {
  ourBeliefsPageStore: PageStoreContract = getModule(OurBeliefsPageStore, this.$store)

  get ourBeliefsCredibilityImageTitle(): string {
    return this.getElementText(5, 0)
  }

  get ourBeliefsCredibilityImageSrc(): string {
    return this.getElementMedia(5, 0)
  }

  get ourBeliefsCredibilityImageTitle2(): string {
    return this.getElementText(5, 1)
  }  

  async getOurBeliefsPageStore(): Promise<void> {
    await this.ourBeliefsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.ourBeliefsPageStore.isLoading) {
      await this.getOurBeliefsPageStore()
    }
  }
}
</script>

<style lang="scss">
.our-beliefs-credibility-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;
}

.our-beliefs-credibility-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.our-beliefs-credibility-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.our-beliefs-credibility-image-credibility-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.our-beliefs-credibility-image-credibility-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
